// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZFpX","right":"styles_right__2KW_s"};